import React from 'react';
import { Translate } from 'react-redux-i18n';

import { UserDTO } from '../../../../network/api/types/compte/UserDTO';
import ConnectionInformationBox from './ConnectionInformationBox';
import EmergencyInformationBox from './EmergencyInformationBox';
import ReinforceSecurityBox from './ReinforceSecurityBox';
import { MonIdentite } from '../../../../network/api/types/compte/MonIdentite';

type Props = {
  myUserDetails: UserDTO,
  myIdentity: MonIdentite,
  openPhotoModal: () => void,
  pseudo: string,
};

function MyAccount(props: Props): React.ReactElement {
  return (
    <div className="manage-account">
      <div className="title-wrapper">
        <h3 className="home-title">
          <Translate value="HOME.MANAGE_ACCOUNT" />
        </h3>
        <div className="home-boxes">
          <div className="left-boxes">
            <ConnectionInformationBox
              openPhotoModal={props.openPhotoModal}
              myIdentity={props.myIdentity}
              pseudo={props.pseudo}
            />
            <div className="box-gap" />
            <EmergencyInformationBox
              myUserDetails={props.myUserDetails}
            />
          </div>
          <div className="box-gap" />
          <ReinforceSecurityBox />
        </div>
      </div>
    </div>
  );
}

export default MyAccount;
